import { Box } from "@mui/material";
import DisplayMoney from "../../../common/custom/DisplayMoney";
import { MeansTestDto } from "../models";

interface Props {
  guardian: MeansTestDto;
}
export default function GuardianSalaryCalculation({ guardian }: Props) {
  const calculateTotalMonthlyAveragedSalaryForGuardian = () => {
    return Math.round(
      (guardian.monthOne + guardian.monthTwo + guardian.monthThree) / 3
    );
  };

  const calculateTotalAnnualIncome = () => {
    return Math.round(calculateTotalMonthlyAveragedSalaryForGuardian() * 12);
  };

  return (
    <Box mt={2}>
      <Box>
        <DisplayMoney
          amount={calculateTotalMonthlyAveragedSalaryForGuardian()}
          label="Monthly Income"
        />
      </Box>
      <Box>
        <DisplayMoney
          amount={calculateTotalAnnualIncome()}
          label="Yearly Income"
        />
      </Box>
    </Box>
  );
}
